/**
 * Portal assignee visibility for internal (BBA) users.
 *
 * `internal_users/{id}.portalAssignable` is toggled from CRM ▸ Internal Users ▸ Users.
 * When false the user is hidden from client-facing assignee pickers (questions, fires,
 * roadmap tasks, etc.). Unset is treated as enabled so existing users stay visible
 * until an Owner explicitly turns them off.
 */
export const isPortalAssignable = (user) => Boolean(user) && user.portalAssignable !== false;

export const filterPortalAssignable = (users = []) => (users || []).filter(isPortalAssignable);
